import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { ButtonModule } from '@fino-ui/button';
import { BaseModalComponent } from '@fino-ui/modal';
import { TranslationModule } from '@fino-ui/translation';
import { FileUploadComponent } from '../file-upload/file-upload.component';
import { InfoComponent } from '../info/info.component';
import { PleaseBePatientComponent } from '../please-be-patient/please-be-patient.component';

export const UPLOAD_TYPES = {
  PDF: 'pdf',
  IMAGE: 'image',
};

@Component({
  selector: 'app-file-upload-modal',
  templateUrl: './file-upload-modal.component.html',
  styleUrl: './file-upload-modal.component.sass',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    TranslationModule,
    PleaseBePatientComponent,
    InfoComponent,
    FileUploadComponent,
    ButtonModule,
  ],
})
export class FileUploadModalComponent extends BaseModalComponent<
  {
    title: string;
    description: string;
    fileType: string;
    hidePatientHint?: boolean;
  },
  string
> {
  @ViewChild('fileUpload') fileUpload!: FileUploadComponent;

  title: string = '';
  description: string = '';
  fileType: string = '';
  hidePatientHint = false;

  fileAsBase64: string = '';

  constructor() {
    super();
    Object.assign(this, this.data ?? {});
  }

  get modalId() {
    return this.title.replace('.title', '.modal');
  }

  get isPdfUpload() {
    return this.fileType === UPLOAD_TYPES.PDF;
  }

  get isImageUpload() {
    return this.fileType === UPLOAD_TYPES.IMAGE;
  }

  chooseNew() {
    this.fileAsBase64 = null;
    this.fileUpload.chooseNew();
  }

  submit() {
    this.result = this.fileAsBase64;
    this.close();
  }

  fileSelected(fileAsBase64) {
    this.fileAsBase64 = fileAsBase64;
  }

  abort() {
    this.close();
  }
}
